import { Observable } from "rxjs";
import { FirebaseUser, Me, Place } from "src/app/interface/user";

export class Login {
  static readonly type = "[User] Login]";
  constructor(public readonly credentials: { email: any; password: any }) {}
}

export class UpdateUserSession {
  static readonly type = "[User] UpdateUserSession]";
  constructor(
    public readonly info: {
      firebaseUser: FirebaseUser;
      me: Me;
      token: string;
      isGhost: string;
    }
  ) {}
}

export class SendRequest {
  static readonly type = "[User] Mutation sendRequest]";
  constructor(public readonly message: string) {}
}

export class UsernameByToken {
  static readonly type = "[User] UsernameByToken]";
  constructor(public readonly meToken: string) {}
}

export class LoginGhost {
  static readonly type = "[User] LoginGhost]";
}

export class GetPlaces {
  static readonly type = "[User] Query placesByUser]";
}

export class GetSubmodules {
  static readonly type = "[User] Query submodulesByModule]";
  constructor(public readonly place: Place) {}
}

export class GetPermission {
  static readonly type = "[User] Query permissionsBySubmoduleAndRole]";
  constructor(public readonly submodule: number) {}
}

export class CleanSelectedPlace {
  static readonly type = "CleanSelectedPlace";
  constructor() {}
}
export class UpdatedUserState {
  static readonly type = "[User] Mutation UpdateUserState]";
  constructor(public readonly id, public readonly FK_UserState: number) {}
}

export class SusbcribeToFCM {
  static readonly type = "[FCM] SusbcribeToFCM]";
}

export class SuscribeToNotification {
  static readonly type = "[FCM] SuscribeToNotification]";
  constructor(public readonly fcmToken: string) {}
}

export class AdminSubscribeToPlace {
  static readonly type = "[FCM] AdminSubscribeToPlace]";
  constructor(public readonly id: string) {}
}

export class SubscribeToPlace {
  static readonly type = "[FCM] SubscribeToPlace]";
  constructor(public readonly id: string, public readonly fcmToken: string) {}
}

export class UpdateNotAvailableProducts {
  static readonly type = "[User] UpdateNotAvailableProducts]";
  constructor(public readonly notAvailableBillDetails) {}
}

export class UpdateDefaultCoin {
  static readonly type = "[User] UpdateDefaultCoin]";
  constructor(public readonly FK_Coin) {}
}

export class GetCoins {
  static readonly type = "[User] GetCoins]";
}

export class UpdateAccount {
  static readonly type = "[User] UpdateAccount]";
}

export class GoogleLogin {
  static readonly type = "[User] GoogleLogin]";
  constructor(public readonly loader) {}
}

export class WatchIdToken {
  static readonly type = "[User] WatchIdToken]";
}

export class SignOut {
  static readonly type = "[User] SignOut]";
}

export class FirebaseAuth {
  static readonly type = "[User] FirebaseAuth]";
  constructor(public readonly user: any, public readonly ghostUID: any) {}
}

export class UserByUID {
  static readonly type = "[User] UserByUID]";
  constructor(
    public readonly uid: string,
    public readonly navigate?: boolean
  ) {}
}

export class ResetPasswordEmail {
  static readonly type = "[User] ResetPasswordEmail]";
  constructor(public readonly email: string) {}
}

export class AllCountries {
  static readonly type = "[User] AllCountries]";
}

export class UpdatePlace {
  static readonly type = "[FileName] UpdatePlace]";
  constructor(public readonly place?: any) {}
}

export class Ninja {
  static readonly type = "[User] Ninja]";
  constructor(public readonly uid: string, public readonly FK_Place: string) {}
}

export class PlaceProfile {
  static readonly type = "[AllProfiles] Query PlaceProfile]";
  constructor(public readonly id: string) {}
}

export class UploadProfileImage {
  static readonly type = "[User] UploadProfileImage]";
  constructor(public readonly file) {}
}

export class SaveImageRouteForProfile {
  static readonly type = "[User] SaveImageRouteForProfile]";
  constructor(
    public fileRef: Observable<any>,
    public readonly FirebaseId: string
  ) {}
}

export class UpdateProfileImage {
  static readonly type = "[User] UpdateProfileImage]";
  constructor(public readonly Route_File, public readonly FirebaseId) {}
}
export class GetPermissionsSubmodules {
  static readonly type = "[User] GetPermissionsSubmodules]";
  constructor(public readonly roleId: number) {}
}

export class UpdateSelectedPlace {
  static readonly type = "[User] Update Selected Place";
  constructor(public payload: Place) {}
}

export class UpdatePlaceLogo {
  static readonly type = "[Place] Update Place Logo";
  constructor(public logo: any) {}
}

export class DeleteDeliveryPlace {
  static readonly type = "[Place] DeleteDeliveryPlace";
  constructor(public placeId: number, public deliveryId: number) {}
}

export class UpdatePlaceDeliveriesCoordinates {
  static readonly type = "[User] Update Place Deliveries Coordinates";
  constructor(
    public placeId: number,
    public lat: number,
    public lng: number,
    public address: string
  ) {}
}
